import { useMutation } from '@apollo/client';
import { DeleteAssetsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteAssetsTRPC } from './useDeleteAssetsTRPC';

export const useDeleteAssets = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [deleteAssetsGraphQL, graphqlState] = useMutation(
    DeleteAssetsDocument,
    {
      update: (cache) => {
        evictField(cache, 'asset');
        evictField(cache, 'asset_aggregate');
      },
    }
  );

  const trpcMutation = useDeleteAssetsTRPC();

  const deleteAssets = async (variables: { Ids: string[] }): Promise<void> => {
    if (trpcEnabled) {
      return trpcMutation.deleteAssets(variables);
    }

    const result = await deleteAssetsGraphQL({
      variables: { Ids: variables.Ids },
    });

    if (!result.data) {
      throw new Error('Failed to delete assets');
    }
  };

  if (trpcEnabled) {
    return {
      deleteAssets,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteAssets,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
